<app-header></app-header>

<div class="min-h-screen flex items-center short:items-start justify-center px-4 sm:px-6 md:px-8 short:pt-24 short:pb-8 bg-cover bg-center"
    [ngStyle]="{ 'background-image': 'url(assets/images/employer-login.png)' }">

    <div class="bg-white p-4 sm:p-6 md:p-8 short:py-3 rounded-lg shadow-md w-full max-w-2xl">
        <div class="flex justify-start mb-4 sm:mb-6 short:mb-2 pb-2 short:pb-1 border-b-[1px]">
            <img src="assets/images/logo-red.png" class="h-10 sm:h-12 md:h-14 short:h-10" />
        </div>

        <h2 class="text-center text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mb-2">
            {{ 'EMPLOYER.PASSWORD.TITLE' | translate }}
        </h2>
        <p class="text-center text-sm sm:text-base text-gray-500 mb-4 sm:mb-6 short:mb-2">
            {{ 'EMPLOYER.PASSWORD.DESCRIPTION' | translate }}
        </p>
        <div class="flex justify-center">
            <div class="w-full max-w-md px-2 sm:px-0">
                <div class="mb-4 sm:mb-6 short:mb-3">
                    <label class="block text-xs sm:text-sm text-gray-600 mb-1">{{ 'EMPLOYER.PASSWORD.EMAIL_LABEL' | translate
                        }}</label>
                    <input type="email" (keydown.enter)="isFormValid() && resetPassword()"
                        class="w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-md focus:outline-none focus:ring-2 focus:ring-red-300"
                        [(ngModel)]="email" placeholder="{{ 'EMPLOYER.PASSWORD.EMAIL_LABEL' | translate }}" />
                    <div *ngIf="errorMessage" class="mt-2 text-xs sm:text-sm text-red-600">
                        {{ errorMessage }}
                    </div>
                </div>

                <button (click)="resetPassword()" [disabled]="!isFormValid() || loading"
                    class="w-full rounded-3xl bg-white border-4 border-red-500 text-red-500 py-3 text-base sm:text-lg font-medium min-h-[48px]"
                    [ngClass]="{ 'opacity-50 cursor-default': !isFormValid() || loading, 'active:bg-red-500 active:text-white': isFormValid() && !loading }">
                    <span *ngIf="!loading">{{ 'EMPLOYER.PASSWORD.RESET_BUTTON' | translate | uppercase }}</span>
                    <span *ngIf="loading">PLEASE WAIT...</span>
                </button>
            </div>
        </div>
        <div class="text-center mt-4 sm:mt-6 short:mt-2">
            <a routerLink="/employer/account/login" class="text-sm sm:text-base text-red-500 hover:underline min-h-[44px] inline-flex items-center">{{
                'EMPLOYER.PASSWORD.BACK_TO_LOGIN' | translate }}</a>
        </div>

        <app-card-footer></app-card-footer>
    </div>
</div>
